import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { formatPrice } from "../../helpers/formatPrice";

import NavigateButton from "../../designComponents/NavigateButton/NavigateButton";

import {
  _AddToCartContainer as AddToCartContainer,
  _TermsOfPurchase as TermsOfPurchase,
  _PriceChanges as PriceChanges,
  _TotalDiscount as TotalDiscount,
  _ErrorContainer as ErrorContainer,
} from "./style";
import {
  DiscountedPrice,
  OrdinaryPrice,
  TotalPriceLabel,
} from "../../views/SummaryView/SummaryViewStyle";
import { Box } from "@mui/material";

const ProceedToCheckout = ({ addToCart, hasErrors, Summary, alias }) => {
  const ArticlesNotAvailableForPurchase = useSelector(
    (state) => state.Result.ArticlesNotaAvilableForPurchace
  );

  function createMarkup(html) {
    return { __html: html };
  }

  if (hasErrors) {
    return (
      <ErrorContainer className="hide-on-print">
        <div
          dangerouslySetInnerHTML={createMarkup(
            alias.bfcArticlesNotAvailableInfoHtml
          )}
        />
        <p>
          {ArticlesNotAvailableForPurchase &&
            ArticlesNotAvailableForPurchase.map((article) => {
              return <span key={article.Sku}>{article.Sku}</span>;
            })}
        </p>
      </ErrorContainer>
    );
  } else {
    return (
      <>
        <NavigateButton
          handleClick={() => addToCart()}
          className="hide-on-print"
          data-id={`AddToCartButton`}
          text={alias.bfcAddToCheckout}
        />

        <span className="delivery-information">
          {Summary.DeliveryInformation}
        </span>
        <TermsOfPurchase href={alias.bfcTermsOfPurchase} target="_blank">
          {alias.bfcStockInfo}
        </TermsOfPurchase>
        <PriceChanges>{alias.bfcDisclaimer}</PriceChanges>
      </>
    );
  }
};

ProceedToCheckout.propTypes = {
  addToCart: PropTypes.func,
  hasErrors: PropTypes.bool,
  Summary: PropTypes.object,
  alias: PropTypes.object,
};

export const AddToCart = ({ onAddToCart }) => {
  const Result = useSelector((state) => state.Result);
  const init = useSelector((state) => state.init);

  const { Errors, Summary } = Result;
  const { currency, alias } = init;

  const discountObjs = Array.isArray(Summary.Discounts) ? Summary.Discounts : [];
  const hasErrors = Errors && Errors.length;

  return (
    <AddToCartContainer hasErrors={hasErrors}>
      <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end'}}>
        {Summary && (
          <>
            {Summary.Price === Summary.OrdinaryPrice ? (
              <>
                <TotalPriceLabel>{alias.bfcTotalPrice}</TotalPriceLabel>
                <span>{Summary.FormatedOrdinaryPrice}</span>
              </>
            ) : (
              <>
                <Box sx={{ display: 'flex', flexDirection: 'row'}}>
                  <OrdinaryPrice>{alias.bfcOrdinaryPrice}:</OrdinaryPrice>
                  &nbsp;
                  <OrdinaryPrice>{Summary.FormatedOrdinaryPrice}</OrdinaryPrice>  
                </Box>

                {discountObjs.map(discountObj => (
                  <TotalDiscount key={discountObj.Discount}>
                    {discountObj.PromotionName}: - {discountObj.FormattedDiscount}
                  </TotalDiscount>
                ))}

                {Summary.ProductDiscount > 0 ? (
                  <TotalDiscount>
                    {alias.bfcDiscount} - {formatPrice(Summary.ProductDiscount, currency)}
                  </TotalDiscount>
                ) : ''}
              
                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline' }}>
                  <TotalPriceLabel>{alias.bfcTotalPrice}</TotalPriceLabel>
                  <DiscountedPrice>{formatPrice(Summary.Price, currency)}</DiscountedPrice>
                </Box>
              </>
            )}
          </>
        )}
      </Box>
      <ProceedToCheckout
        addToCart={onAddToCart}
        hasErrors={hasErrors}
        Summary={Summary}
        alias={alias}
      />
    </AddToCartContainer>
  );
};

AddToCart.propTypes = {
  onAddToCart: PropTypes.func,
};
